import axios from 'axios'

const actions = {
    async signUp({ dispatch }, userObj) {
        let response = await axios.post('/users/signup', userObj)
        if(!response.data.error){
            // intentionally removed the return keyword here
            dispatch('signIn', userObj) 
        }
        // this return here allows the users see error msgs during signup
        return response.data
    },

    async verifyEmail({ dispatch }, userObj) {
        let response = await axios.post(`/security/emailConfirmation`, userObj)
        if(!response.data.error){
            dispatch('updateUserVal', response.data.result)
        }
        return response.data
    },
    
    async resendVerifyLink({ _ }, userObj) {
        let response = await axios.post(`/security/resendVerificationEmail`, userObj)
        return response.data
    }
}

export default {
    actions
}